<template>
  <div class="chart chart-move" >
    <!-- <v-layout  v-if="editMode" class="chart-tool">
      <v-flex
        row>
        <v-spacer/>
        <v-btn
          v-scroll-to="'#down'"
          slot="activator"
          flat
          icon
          dark
          @click="$emit('duplicate-chart', slice)">
          <v-tooltip bottom>
            <v-icon
              slot="activator"
              small>file_copy</v-icon>
            <span>Duplicate Chart</span>
          </v-tooltip>
        </v-btn>
        <v-btn
          slot="activator"
          flat
          icon
          dark
          @click="$emit('edit-chart', chartId)">
          <v-tooltip bottom>
            <v-icon
              slot="activator"
              small>build</v-icon>
            <span>Edit Chart</span>
          </v-tooltip>
        </v-btn>
        <v-btn
          slot="activator"
          flat
          icon
          dark
          @click="$emit('deleteChart', chartId)">
          <v-tooltip bottom>
            <v-icon
              slot="activator"
              small>remove_circle_outline</v-icon>
            <span>Delete Chart</span>
          </v-tooltip>
        </v-btn>
      </v-flex>
    </v-layout> -->
    <v-layout v-if="editMode" class="chart-tool" >
      <v-spacer />
      <v-menu
        transition="slide-y-transition"
        offset-y
        :close-on-content-click="false"
      >
          <template v-slot:activator="{ on }">
            <v-btn dark icon v-on="on" style="outline: none;" @click="action">
              <v-icon>more_vert</v-icon>
            </v-btn>
          </template>

          <v-list>
            <v-list-tile @click="$emit('duplicate-chart', slice)" v-scroll-to="'#down'">
              <v-icon size="16" style="color: #757575;">file_copy</v-icon>
              <v-list-tile-title style=" margin-left: 5px; color: #757575;">Duplicate</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="$emit('edit-chart', chartId)" >
              <v-icon size="16" style="color: #757575;">build</v-icon>
              <v-list-tile-title  style=" margin-left: 5px; color: #757575;">Edit</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="$emit('deleteChart', chartId)" >
              <v-icon size="16" style="color: #757575;">remove_circle_outline</v-icon>
              <v-list-tile-title  style=" margin-left: 5px; color: #757575;">Delete</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
    </v-layout>
    <v-layout v-else-if="previewMode === true" mx-0 my-1>
    </v-layout>
    <v-layout v-else class="extand-chart">
      <v-flex row >
        <v-spacer></v-spacer>
        <v-btn
          flat
          icon
          dark
          style="outline: none;"
          slot="activator"
          class="btn-zoom-chart"
          @click="$emit('full-chart', chartId)"
        >
          <v-tooltip bottom>
            <v-icon slot="activator">zoom_in</v-icon>
            <span>Full Chart</span>
          </v-tooltip>
        </v-btn>
      </v-flex>
    </v-layout>
    <p v-if="host !== ''"><font size="3" color="#f0ffff" style="margin-top: 50px;">{{host}}</font><sup><font size="2" color="#C17F3F" style="margin-top: 50px;"> BETA</font></sup></p>
    <v-chart
      ref="options"
      :init-options="initOptions"
      :options="options"
      :autoresize="true"
      :style="{ height, width }"
      @mouseover="ipLookup"
      @init="initChart"/>
  </div>
</template>

<script>
import ECharts from 'vue-echarts/components/ECharts'
import 'echarts/lib/chart/map'
import 'echarts/lib/component/visualMap'
import 'echarts/map/js/world'
import axios from 'axios'

export default {
  name: 'Sankey',
  components: {
    'v-chart': ECharts
  },
  props: {
    text: {
      type: String,
      default: ''
    },
    user_index: {
      type: String,
      default: ''
    },
    user_inst: {
      type: String,
      default: ''
    },
    startTime: {
      type: [String, Number],
      default: 0
    },
    endTime: {
      type: [String, Number],
      default: Date.now()
    },
    topLimit: {
      type: Number,
      default: 5
    },
    field_st: {
      type: String,
      default: ''
    },
    field_nd: {
      type: String,
      default: ''
    },
    orderby: {
      type: String,
      default: '_count'
    },
    fieldsum: {
      type: String,
      default: ''
    },
    stores: {
      type: Array,
      default: function () {
        return []
      }
    },
    subFilter: {
      type: String,
      default: ''
    },
    chartName: {
      type: String,
      default: 'Untitled'
    },
    width: {
      type: [String, Number],
      default: '100%'
    },
    height: {
      type: String,
      default: '90%'
    },
    editMode: {
      type: Boolean,
      default: false
    },
    chartId: {
      type: String,
      default: ''
    },
    slice: {
      type: Object,
      default: function () {
        return {}
      }
    },
    index_now: {
      type: String
    },
    previewMode: {
      type: Boolean,
      default: false
    },
    reloadchart: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      chart: null,
      data: [],
      links: [],
      initOptions: { renderer: 'canvas' },
      options: {},
      sub: '',
      host: ''
    }
  },
  async created () {
    if (!this.user_index) {
      this.user_index = this.index_now
    }
  },
  async mounted () {
    await this.initChart()
    await this.beforeload()
  },
  watch: {
    startTime: {
      handler: function (user_index) {
        if (this.user_index) {
          this.initChart()
        }
      }
    },
    endTime: {
      handler: function (user_index) {
        if (this.user_index) {
          this.initChart()
        }
      }
    },
    stores: {
      handler: function (user_index) {
        if (this.user_index) {
          this.initChart()
        }
      }
    },
    text: {
      handler: function (user_index) {
        if (this.user_index) {
          this.initChart()
        }
      }
    },
    user_index: {
      handler: function (user_index) {
        if (this.user_index) {
          this.initChart()
        }
      }
    },
    index_now: {
      handler: function (user_index) {
        this.user_index = this.index_now
      }
    },
    reloadchart: {
      handler: function (val) {
        this.options = {}
        this.initChart()
      }
    }
  },
  methods: {
    async ipLookup (ip) {
      let response
      if (ip.name.match(/^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/)) {
        response = await axios.post(apiUrl + '/api/status/nslookup', {
          ip: ip.name
        })
      } else {}
      this.host = response.data.host
    },
    async initChart () {
      this.options = {}
      this.data = []
      this.links = []
      this.$refs.options.showLoading({
        color: '#4ea397',
        maskColor: 'transparent',
        textColor: '#ccc'
      })
      if (this.subFilter !== '*') {
        this.sub = `${this.subFilter}`
        if (this.text) {
          this.sub += ` AND ${this.text}`
        }
      }
      let response = await axios.post(apiUrl + '/api/query/corre', {
        start: this.startTime,
        end: this.endTime,
        instance: this.user_inst,
        index: this.user_index,
        field_st: this.field_st,
        field_nd: this.field_nd,
        fieldsum: this.fieldsum,
        orderby: this.orderby,
        limit: this.topLimit,
        stores: this.stores,
        sub: this.sub,
        text: this.text
      })
      this.$refs.options.hideLoading()
      // if (response.data.msg) {
      //   this.options = {
      //     title: {
      //       show: true,
      //       text: this.chartName,
      //       textStyle: {
      //         color: '#ccc',
      //         fontFamily: 'Avenir, Helvetica, Arial, sans-serif'
      //       }
      //     },
      //     backgroundColor: 'transparent',
      //     graphic: {
      //       type: 'text',
      //       left: 'center',
      //       top: 'middle',
      //       style: {
      //         text: 'Request time out.',
      //         font: 'bolder 16px Avenir, Helvetica, Arial, sans-serif',
      //         fill: '#ccc'
      //       }
      //     },
      //     series: []
      //   }
      //   return
      // }
      if (Array.isArray(response.data) && response.data.length) {
        for (let source of response.data) {
          for (let target of source.target.buckets) {
            this.links.push({
              source: source.key,
              target: target.key,
              value: this.orderby === '_count'
                      ? target.doc_count
                      : target.bandwidth.value
            })
          }
        }

        for (let link of this.links) {
          if (!this.data.find(datum => datum.name === link.source)) {
            this.data.push({ name: link.source })
          }
          if (!this.data.find(datum => datum.name === link.target)) {
            this.data.push({ name: link.target })
          }
        }
        // console.log(this.data)
        // console.log(this.links)
        this.options = {
          title: {
            show: true,
            text: this.chartName,
            textStyle: {
              color: '#ccc'
            }
          },
          backgroundColor: 'transparent',
          tooltip: {
            trigger: 'item'
          },
          color: ['#67001f', '#b2182b', '#d6604d', '#f4a582', '#fddbc7', '#d1e5f0', '#92c5de', '#4393c3', '#2166ac', '#053061'],
          series: [{
            top: '15%',
            type: 'sankey',
            layout: 'none',
            data: this.data,
            links: this.links,
            lineStyle: {
              color: 'white'
            },
            label: {
              color: '#ccc'
            },
            tooltip: {
              formatter: (params) => {
                if (params.dataType === 'edge') {
                  let data = params.data
                  let tooltip = `${data.source} -- ${data.target}: `
                  if (this.orderby === '_count') {
                    return tooltip + `${data.value}`
                  } else {
                    return tooltip +
                    (data.value <= Math.pow(2, 10)
                      ? `${data.value} Bytes`
                      : data.value <= Math.pow(2, 20)
                          ? `${Math.round(data.value / Math.pow(2, 10))} KB`
                          : data.value <= Math.pow(2, 30)
                              ? `${Math.round(data.value / Math.pow(2, 20))} MB`
                              : `${Math.round(data.value / Math.pow(2, 30))} GB`)
                  }
                } else {
                  return `${params.name}`
                }
              }
            }
          }]
        }
      } else {
        this.options = {
          title: {
            show: true,
            text: this.chartName,
            textStyle: {
              color: '#ccc',
              fontFamily: 'Avenir, Helvetica, Arial, sans-serif'
            }
          },
          backgroundColor: 'transparent',
          graphic: {
            type: 'text',
            left: 'center',
            top: 'middle',
            style: {
              text: 'No data',
              font: 'bolder 16px Avenir, Helvetica, Arial, sans-serif',
              fill: '#ccc'
            }
          },
          series: []
        }
      }
    },
    beforeload () {
      this.$emit('loadChart', 'load', 'x-sankey')
    },
    action () {
      this.$emit('actionToChart')
    }
  }
}
</script>

<style scoped>
/* .chart {
  min-height: 400px
} */
</style>



// WEBPACK FOOTER //
// src/components/x-sankey.vue